import { ComponentChildren } from 'preact';
import { Flex } from '../UNSAFE_Flex';
import { Size } from '../utils/UNSAFE_size';

type Props = {
  children: ComponentChildren;
};

export function BaseSwatchViewLayout({ children }: Props) {
  const gap = ['2x' as Size, '2x' as Size] as [Size, Size];
  return (
    <Flex wrap="wrap" gap={gap}>
      {children}
    </Flex>
  );
}
